import { Dispatch, SetStateAction, useContext } from 'react';
import styled from 'styled-components';
import { PropertySaleType } from '../../../types';
import { useTranslation } from 'next-i18next';
import { saleTypes } from '../../../constants';
import { SearchFiltersTypes } from '../../../../../reducers/search-filters/reducer';
import { SearchFiltersActionTypes } from '../../../../../reducers/search-filters/actions';
import {
  SearchContext,
  SearchContextInterface
} from '../../../../search-new/context/SearchContext';
import { useSelector } from 'react-redux';

interface SaleTypeTabsProps {
  activeSaleTab: PropertySaleType;
  setActiveSaleTab: Dispatch<SetStateAction<PropertySaleType>>;
}

const SaleTypeTabs = ({
  activeSaleTab,
  setActiveSaleTab
}: SaleTypeTabsProps) => {
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { t } = useTranslation('common');

  const handleSaleTabClick = (type: PropertySaleType) => {
    setActiveSaleTab(type);
    if (type === PropertySaleType.NAWY_NOW) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.SALE_TYPE,
          value: []
        }
      });
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.NAWY_NOW,
          value: true
        }
      });
    } else {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.NAWY_NOW,
          value: false
        }
      });
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.SALE_TYPE,
          value: type === PropertySaleType.All ? [] : [type]
        }
      });
    }
  };

  return (
    <SaleTypeTabsContainer>
      {saleTypes.map((type: PropertySaleType) => (
        <SaleTypeChip
          isActive={activeSaleTab === type}
          key={type}
          className={`sale-type-chip ${activeSaleTab === type ? 'active' : ''}`}
          onClick={() => handleSaleTabClick(type)}
        >
          {isMobile && type == PropertySaleType.Developer_Sale
            ? t('developer')
            : t(type)}
        </SaleTypeChip>
      ))}
    </SaleTypeTabsContainer>
  );
};

const SaleTypeTabsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SaleTypeChip = styled.div<{ isActive: boolean }>`
  display: flex;
  min-width: 48px;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 8px 0px;
  background-color: transparent;
  color: #8e8e8e;
  border-bottom: 1px solid #d3dbe6;
  font-size: 13px;
  font-family: materialRegular;
  cursor: ${props => (props.isActive ? 'unset' : 'pointer')};
  &.active {
    border-bottom: 1px solid #015c9a;
    color: #015c9a;
    font-family: materialMedium;
  }
`;

export default SaleTypeTabs;
